import React, { useState } from "react";
// import { useSelector } from "react-redux";
import { FiltersWrapper, Sorting } from "./filters-styles";
import FilterContainer from "../../library/SearchFilter/SearchFilterContainer";
import FilterOption from "../../library/SearchFilter/SearchFilterOption";
import { SearchFilterProvider } from "../../library/SearchFilter";
// interface AppState {
//   employerAnalytics?: {
//     resetDefaultFilters?: {
//       isFirstRun?: boolean;
//     };
//   };
// }
type Props = {
  filters: {
    sortOrder?: string;
    sortBy?: object;
  };
  // loadJobPerformance: (filterData?: object) => void;
  filterAction: any;
  analyticsFilter: any;
  resetDefaultFilters: any;
  dataFilters: any;
  setDataFilters: any;
};

export const Sort = (props: Props) => {
  const [noResult] = useState(false);
  const {
    filters,
    filterAction,
    analyticsFilter,
    resetDefaultFilters,
    dataFilters,
    setDataFilters,
  } = props;
  const submit = () => {
    analyticsFilter(filters, filterAction, true, dataFilters);
    resetDefaultFilters({ isFirstRun: false });
  };

  const reset = () => {
    analyticsFilter(filters, filterAction, true, dataFilters);
    resetDefaultFilters({ isFirstRun: true });
  };

  const sortSubmit = (sortOrder?: string, sortBy?: any) => {
    dataFilters.sortOrder = sortOrder ? sortOrder : dataFilters.sortOrder;
    dataFilters.sortBy = sortBy ? sortBy : dataFilters.sortBy;
    analyticsFilter(filters, filterAction, true, dataFilters);
    resetDefaultFilters({ isFirstRun: false });
  };

  // isOutsideRange function to restrict dates
  return (
    <SearchFilterProvider
      initialValue={dataFilters}
      onChange={(data: any) => {
        setDataFilters(data);
      }}
      handleReset={reset}
      handleSubmit={submit}
      handleSortSubmit={sortSubmit}
    >
      <FiltersWrapper
        data-id="employer-analytics-filters"
        id="employer-analytics-filters"
        className="animated fadeIn delay-1"
        datePickerActive={true}
      >
        <FilterContainer
          name="Sort By"
          analytics={true}
          filters={filters}
          dataFilters={dataFilters}
          setDataFilters={setDataFilters}
        >
          {noResult ? (
            <div style={{ padding: "20px 20px", textAlign: "center" }}>
              No Sorting found
            </div>
          ) : (
            <>
              {filters.sortBy && Object.keys(filters.sortBy).length > 0 && (
                <Sorting>
                  {Object.entries(filters?.sortBy || {}).map(([key, value]) => (
                    <FilterOption
                      single={true}
                      key={key}
                      name="sortBy"
                      value={String(key)}
                    >
                      {value as string}
                    </FilterOption>
                  ))}
                </Sorting>
              )}
            </>
          )}
        </FilterContainer>
      </FiltersWrapper>
    </SearchFilterProvider>
  );
};

export default Sort;
